import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'additional_properties_by_sample_id';

export const useAdditionalPropertiesBySampleIdTranslation = (): UseTranslationResponse<string, string> => (
  useTranslation('entities', { keyPrefix })
);

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    light: 'Засвеченность',
    dark: 'Затемненность',
    blurriness: 'Размытость',
    specularity: 'Наличие бликов',
    illumination: 'Равномерность освещения',
    head_pose_roll: 'Угол отклонения головы вправо/влево (roll)',
    head_pose_pitch: 'Угол наклона головы вверх/вниз (pitch)',
    head_pose_yaw: 'Угол поворота головы вправо/влево (yaw)',
    gaze_pitch: 'Угол наклона взгляда вверх/вниз (pitch)',
    gaze_yaw: 'Угол поворота взгляда вправо/влево (yaw)',
    mouth_state: 'Состояние рта',
    eyes_state: 'Состояние глаз',
    left_eye: 'Левый',
    right_eye: 'Правый',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    light: 'Overexposure',
    dark: 'Darkness',
    blurriness: 'Blurriness',
    specularity: 'Specularity',
    illumination: 'Illumination uniformity',
    head_pose_roll: 'Head tilt right/left (roll)',
    head_pose_pitch: 'Head tilt up/down (pitch)',
    head_pose_yaw: 'Head turn right/left (yaw)',
    gaze_pitch: 'Gaze tilt up/down (pitch)',
    gaze_yaw: 'Gaze turn right/left (yaw)',
    mouth_state: 'Mouth state',
    eyes_state: 'Eyes state',
    left_eye: 'Left',
    right_eye: 'Right',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    light: 'Superexposição',
    dark: 'Escurecimento',
    blurriness: 'Desfoque',
    specularity: 'Brilho',
    illumination: 'Uniformidade da iluminação',
    head_pose_roll: 'Inclinação da cabeça direita/esquerda (roll)',
    head_pose_pitch: 'Inclinação da cabeça para cima/baixo (pitch)',
    head_pose_yaw: 'Rotação da cabeça direita/esquerda (yaw)',
    gaze_pitch: 'Inclinação do olhar para cima/baixo (pitch)',
    gaze_yaw: 'Rotação do olhar direita/esquerda (yaw)',
    mouth_state: 'Estado da boca',
    eyes_state: 'Estado dos olhos',
    left_eye: 'Esquerdo',
    right_eye: 'Direito',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    light: 'Sobreexposición',
    dark: 'Oscuridad',
    blurriness: 'Desenfoque',
    specularity: 'Brillo',
    illumination: 'Uniformidad de iluminación',
    head_pose_roll: 'Inclinación de la cabeza derecha/izquierda (roll)',
    head_pose_pitch: 'Inclinación de la cabeza arriba/abajo (pitch)',
    head_pose_yaw: 'Giro de la cabeza derecha/izquierda (yaw)',
    gaze_pitch: 'Inclinación de la mirada arriba/abajo (pitch)',
    gaze_yaw: 'Giro de la mirada derecha/izquierda (yaw)',
    mouth_state: 'Estado de la boca',
    eyes_state: 'Estado de los ojos',
    left_eye: 'Izquierdo',
    right_eye: 'Derecho',
  },
}) : {}) as Record<string, unknown>;
